var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "x-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.9183 18.3332C15.5206 18.3332 19.2516 14.6022 19.2516 9.99984C19.2516 5.3975 15.5206 1.6665 10.9183 1.6665C6.31596 1.6665 2.58496 5.39742 2.58496 9.99984C2.58496 14.6023 6.31596 18.3332 10.9183 18.3332ZM7.82913 8.089C7.50363 7.7635 7.50363 7.23617 7.82913 6.91059C8.15463 6.585 8.68196 6.58509 9.00754 6.91059L10.9184 8.82142L12.8292 6.91059C13.1547 6.58509 13.682 6.58509 14.0076 6.91059C14.3332 7.23609 14.3331 7.76342 14.0076 8.089L12.0968 9.99984L14.0076 11.9107C14.3331 12.2362 14.3331 12.7635 14.0076 13.0891C13.8449 13.2518 13.6316 13.3333 13.4185 13.3333C13.2053 13.3333 12.992 13.2518 12.8293 13.0891L10.9185 11.1783L9.00763 13.0891C8.84488 13.2518 8.63163 13.3333 8.41846 13.3333C8.20529 13.3333 7.99204 13.2518 7.82929 13.0891C7.50379 12.7636 7.50379 12.2363 7.82929 11.9107L9.74013 9.99984L7.82913 8.089Z",
    fill: "#00E7FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossIcon);
export default __webpack_public_path__ + "static/media/crossIcon.fdb70f78e50344726999dd646f88e419.svg";
export { ForwardRef as ReactComponent };